import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';
import { PlatformSettingsForm } from './components/PlatformSettingsForm';

export const Route = createFileRoute('/r/$restaurantId/s/platform-settings')({
  component: Component,
});

function Component() {
  const { restaurantId } = Route.useParams();
  const { data: restaurant, isPending } = useQuery(api.restaurants.getById, { restaurantId });

  if (isPending) return <LoadingIcon />;
  if (!restaurant) return null;

  return <PlatformSettingsForm restaurant={restaurant} restaurantId={restaurantId} />;
}
